export function getCookies(cookiesName: string): string {
  return (
    document.cookie
      .split('; ')
      .find((row) => row.startsWith(`${cookiesName}=`))
      ?.split('=')[1] || ''
  )
}
